import { render, staticRenderFns } from "./DetailsItemsDocuments.html?vue&type=template&id=14ded5dc&scoped=true&external"
import script from "./DetailsItemsDocuments.js?vue&type=script&lang=js&external"
export * from "./DetailsItemsDocuments.js?vue&type=script&lang=js&external"
import style0 from "./DetailsItemsDocuments.scss?vue&type=style&index=0&id=14ded5dc&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ded5dc",
  null
  
)

export default component.exports